exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-7e0ea373]{text-align:center}.btn-export[data-v-7e0ea373]{text-align:right;margin-bottom:.25rem}.break-word[data-v-7e0ea373]{word-break:break-all}.colour-pdf[data-v-7e0ea373]{color:red}.colour-excel[data-v-7e0ea373]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e0ea373","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportes/files/FilesByRegistrationDate.vue
// module id = 231
// module chunks = 58